module.exports = __webpack_public_path__ + "static/img/slide1.2177c58c.png";